module.exports = __webpack_public_path__ + "img/check.c5fad853.svg";